import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import DialogComponent from 'Components/UI/Dialog';
import NavigationWithContext from 'Components/ComponentLibrary/Organisms/NavigationWithContext';
import DialogTitle from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogTitle';
import DialogContent from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/DialogContent';
import ModalForm from 'Views/Page/Content/Modal/Components/ModalForm';
import React from 'react';
import PropTypes from 'prop-types';
import { dataAttrs } from 'Helpers/Testing';
import { useMaybeNavigationContext } from 'Organisms/NavigationWithContext/NavigationContext';

const useStyles = buildUseStyles('Template', (() => ({
  title: {
    width: '100%',
  },
  actions: {
    width: '100%',
  },
  dialogPaper: {
    width: '100%',
  },
})));

/**
 * @deprecated use Dialog2
 */
export const LegacyDialog = ({
  Layout,
  metaOverrideSet,
  modalSize,
  test,
  forceFullScreen,
  limitedMaxHeight,
  forceNotFullScreen,
  onlyRenderLayout,
  disableBackdropClickClosure,
}) => {
  const classes = useStyles();

  const {
    modalCollection,
    clearModalCollection,
    actionsRef,
    titleRef,
  } = useModalContext();
  const isMobile = useMobileLayout();
  const navigationContext = useMaybeNavigationContext();
  const isFullScreen = !forceNotFullScreen && (forceFullScreen || isMobile);

  return (
    <DialogComponent
      {...dataAttrs('legacy-dialog-root', modalCollection?.resources()?.head())}
      onClose={() => {
        clearModalCollection();
      }}
      maxWidth={modalSize}
      fullScreen={isFullScreen}
      classes={{
        paper: classes.dialogPaper,
      }}
      open={modalCollection}
      disableEnforceFocus
      test={test}
      disableBackdropClickClosure={disableBackdropClickClosure}
    >
      {/* Modal gets its own navigation and navigation context when in fullscreen */}
      {isFullScreen && navigationContext && <NavigationWithContext />}
      <DialogTitle>
        <div className={classes.title} ref={titleRef} />
      </DialogTitle>
      <DialogContent>
        <ModalForm
          limitedMaxHeight={limitedMaxHeight}
          onlyRenderLayout={onlyRenderLayout}
          Layout={Layout}
          metaOverrideSet={metaOverrideSet}
        />
      </DialogContent>
      <div className={classes.actions} ref={actionsRef} />
    </DialogComponent>
  );
};

LegacyDialog.defaultProps = {
  limitedMaxHeight: false,
  onlyRenderLayout: false,
  forceFullScreen: false,
};

LegacyDialog.propTypes = {
  Layout: PropTypes.object.isRequired,
  metaOverrideSet: PropTypes.object.isRequired,
  modalSize: PropTypes.string.isRequired,
  test: PropTypes.string.isRequired,
  forceFullScreen: PropTypes.bool,
  limitedMaxHeight: PropTypes.bool,
  onlyRenderLayout: PropTypes.bool,
  forceNotFullScreen: PropTypes.bool.isRequired,
  disableBackdropClickClosure: PropTypes.bool.isRequired,
};
